import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyleRecommendedTopics = styled.div`
  border: 1px solid #e4e8ec;
  margin-top: 24px;
  background-color: ${theme.colors.white};
  border-radius: 4px;

  ${MediaQueries.mbUp} {
    padding: 24px;
  }
  ${MediaQueries.mbDown} {
    padding: 16px;
    margin: 24px 16px;
  }
`

export const StyledScrollListContainer = styled.div`
  padding: 16px 0;
  .bullet-nav {
    z-index: 1;
    bottom: -24px;
  }

  .grid-layout {
    align-content: space-between;
  }

  .healthTools {
    .container
      > .section:first-of-type
      > .grid-layout
      > .item-grid
      > a
      > div
      > div:last-child {
      overflow: hidden;
      max-height: 3.9em;
    }
  }
`

export const StyledFooterGroup = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0 16px;

  & > :last-child > h5 {
    display: flex;
    align-items: center;

    & > {
      margin-left: 8px;
    }
  }

  ${MediaQueries.mbDown} {
    padding: 0 8px;
  }

  ${MediaQueries.mbUp} {
    & > :last-child {
      margin-top: 4px;
    }
  }

  .chevron-right-icon {
    width: 16px;
    height: 16px;
  }
`

export const StyledSeeAllButton = styled.a`
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 12px 24px;
  border: 1px solid ${theme.colors.primaryActive};
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  h5 {
    color: ${theme.colors.primaryActive};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
`
